import { useCallback, useEffect, useState } from "react";

import { CALL_STATES } from "./../../constants";

const useCall = () =>{
    const [activeState, setActiveState] = useState(CALL_STATES.IN_CALL);
    
    useEffect(()=>{
        setActiveState(CALL_STATES.IN_CALL);
    },[]);

    const handleSetActiveState = useCallback((incomingState)=>{
        setActiveState(incomingState);
    },[]);

    return {
        activeState,
        handleSetActiveState
    }
}

export default useCall;